<template>
    <div class="container-fluid" >
        
        <div class="mr-3 ml-3">
            <div class="row justify-content-center">
                <div class="col-md-3 mt-3" v-if="hasAccess('contract')">
                    <router-link to="/admin/contract-list">
                        <div class="widget-stat card bg-success" style="box-shadow:rgb(203 203 203) 1px 1px 1px 1px">
                            <div class="card-body p-3">
                                <div class="media">
                                    <span class="me-1">
                                        <img src="../assets/images/icons/contratos_w.png" width="35" />
                                    </span>
                                    <div class="media-body text-white text-center">
                                        <p class="mt-3" style="font-size: 14px !important">
                                            Contratos
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-md-3 mt-3" v-if="hasAccess('orders')">
                    <router-link to="/admin/order-list">
                        <div class="widget-stat card bg-info2" style="box-shadow:rgb(203 203 203) 1px 1px 1px 1px;background-color: #daffc4;">
                            <div class="card-body p-3">
                                <div class="media">
                                    <span class="me-1">
                                        <i class="flaticon-044-file"></i>
                                    </span>
                                    <div class="media-body text-white text-center">
                                        <p class="mt-3" style="font-size: 14px !important">
                                            Pedidos
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-md-3 mt-3" v-if="hasAccess('invoices')">
                    <router-link to="/admin/invoice-list">
                        <div class="widget-stat card bg-danger" style="box-shadow:rgb(203 203 203) 1px 1px 1px 1px;background-color: #daffc4;">
                            <div class="card-body p-3">
                                <div class="media">
                                    <span class="me-1">
                                        <img src="../assets/images/icons/financeiro_w.png" width="35" />
                                    </span>
                                    <div class="media-body text-white text-center">
                                        <p class="mt-3" style="font-size: 14px !important">
                                            FINANCEIRO
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-md-3 mt-3" v-if="hasAccess('order-delivered')">
                    <router-link to="/admin/order-finished-list">
                        <div class="widget-stat card bg-orange" style="box-shadow:rgb(203 203 203) 1px 1px 1px 1px;background-color: #daffc4;">
                            <div class="card-body p-3">
                                <div class="media">
                                    <span class="me-2">
                                        <img src="../assets/images/icons/entregas_w.png" width="35" />
                                    </span>
                                    <div class="media-body text-white text-center">
                                        <p class="mt-3" style="font-size: 14px !important">
                                            Entregas
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    
        <div class="mr-3 ml-3">
            <dashboard></dashboard>
        </div>
    </div>
</template>

<script>
    import Dashboard from "./Dashboard.vue";

    export default {
        components: {
            Dashboard,
        },
        data() {
            return {};
        },
        methods: {
            hasAccess(button){

                let contract = [2]

                let orders  = [9, 10, 11, 12, 13, 14, 15]

                let invoices = [3, 4, 5]

                let orderDelivered = [13];

                if(button == 'contract'){
                    return (this.$store.getters.user.access.some(item => contract.includes(item)))                    
                } else if(button == 'orders'){
                    return (this.$store.getters.user.access.some(item => orders.includes(item)))                    
                } else if(button == 'invoices'){
                    return (this.$store.getters.user.access.some(item => invoices.includes(item)))                    
                } else if(button == 'order-delivered'){
                    return (this.$store.getters.user.access.some(item => orderDelivered.includes(item)))  
                }
            },
            brNumber(number) {
                let value_converted = parseFloat(number);
                let value_fixed = value_converted.toFixed(2);
                let value_replaced = value_fixed.replaceAll(".", ",");

                return "R$ " + value_replaced;
            },
        },
        mounted() {
        },
    };
</script>

<style scoped>
    .bg-info2 {
        background-color: #51a6f5 !important;
    }

    .widget-stat .card .bg-success {
        height: 10em;
    }
</style>